import { render, staticRenderFns } from "./mytpp-annual-certifications.vue?vue&type=template&id=76a96879&scoped=true"
import script from "./mytpp-annual-certifications.vue?vue&type=script&lang=js"
export * from "./mytpp-annual-certifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a96879",
  null
  
)

export default component.exports